import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  useParams } from "react-router-dom";
import { FaTasks, FaCheckCircle, FaPause, FaCalendarAlt,} from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { IoIosArrowForward } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { fetchApi } from "../../../utlis/axios";
import RichTextEditor1 from "./RichTextEditor1";
import { addToast } from "../../../Redux/Slices/toast-slice";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Calendar from "./Calendar";
import { BiSolidDollarCircle } from "react-icons/bi";
import { FaCalendar } from "react-icons/fa6";
import { AiFillEdit } from "react-icons/ai";
import { FaClipboardList } from "react-icons/fa";

const ProjectDetail = ({ setOpen, projectId, editingMiletone, setEditingMileStone }) => {
  const { theme } = useSelector((state) => state.theme);
  const { id } = useParams();
  const dispatch = useDispatch()
  const { userInfo } = useSelector((state) => state.auth);
  const [milestones, setMilestones] = useState([]);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [selectedOption1, setSelectedOption1] = useState("in-progress");
  const [isModalOpen, setShowModal] = useState(false);
  const [creating, setCreating] = useState(false);
  const [milstoneData, setMileStoneData] = useState({
    title: "",
    amount: "",
    description: "",
    status: selectedOption1,
    project: id,
    started_at: '',
    completed_at: ''
  });
  const [startDateDropdown, setStartDateDropdown] = useState(false);
  const [endDateDropdown, setEndDateDropdown] = useState(false)
  const [mdeleting, setMDeleting] = useState(false);
  const [mileStoneState, setMileStoneState] = useState("new");
  const [mileStoneId, setMileStoneId] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  
  useEffect(() => {
    if (editingMiletone) {
      setMileStoneData({
        title: editingMiletone.title,
        amount: editingMiletone.amount,
        description: editingMiletone.description,
        status: editingMiletone.status,
        project: editingMiletone.project,
        started_at: editingMiletone.start_date,
        completed_at: editingMiletone.end_date
      });
      setSelectedOption1(editingMiletone.status);
      setMileStoneState("edit");
      setMileStoneId(editingMiletone.id);
      setIsEditing(true);
    }
  }, [editingMiletone]);

  const options = [
    { label: "canceled", icon: <FcCancel className="w-4 h-4 mr-2" /> },
    { label: "paused", icon: <FaPause className="w-4 h-4 mr-2" /> },
    { label: "in-progress", icon: <FaTasks className="w-4 h-4 mr-2" /> },
    { label: "completed", icon: <FaCheckCircle className="w-4 h-4 mr-2" /> },
  ];
  




  const getMilestones = async () => {
    try {
      const res = await fetchApi.get(`/project-milestones/?project=${id}`, {
        headers: { Authorization: `Bearer ${userInfo.access_token}` },
      });
      if (res.status === 200) {
        setMilestones(res.data.results);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: 'error' }));
    }
  };
 

  const handleSubmit = async (event) => {
    if (
      !milstoneData.title ||
      !milstoneData.amount ||
      !milstoneData.description
    ) {
      dispatch(addToast({ message: "Please fill all fields", type: 'warn' }));
      return;
    }
    setCreating(true);
    try {
      const mdata = new FormData();
      mdata.append("title", milstoneData.title);
      mdata.append("amount", milstoneData.amount);
      mdata.append("description", milstoneData.description);
      mdata.append("status", selectedOption1);
      mdata.append("project", projectId);
      if (milstoneData.started_at) {
        mdata.append("started_at", milstoneData.started_at)
      }
      if (milstoneData.completed_at) {
        mdata.append("completed_at", milstoneData.completed_at)
      }
      const res = await fetchApi.post("/project-milestones/", mdata, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`, // Only include Authorization
        },
      });

      if (res.status === 201) {
        setMilestones((prev) => [...prev, res.data])
        dispatch(addToast({ message: 'Milestone created successfully', type: 'success' }));
        setMileStoneData({
          title: "",
          amount: "",
          description: "",
          status: selectedOption1,
        });
        setSelectedOption1('in-progress');
        setOpen(false);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: 'error' }));
    } finally {
      setCreating(false);
    }
  };
  const handleUpdate = async (id) => {
    setCreating(true);
    try {
      const mdata = new FormData();
      mdata.append("title", milstoneData.title);
      mdata.append("amount", milstoneData.amount);
      mdata.append("description", milstoneData.description);
      mdata.append("status", selectedOption1);
      if (milstoneData.started_at) {
        mdata.append('started_at', milstoneData.started_at);
      }
      if (milstoneData.completed_at) {
        mdata.append('completed_at', milstoneData.completed_at)
      }
      const res = await fetchApi.put(`/project-milestones/${id}/`, mdata, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`, // Only include Authorization
        },
      });

      if (res.status === 200) {
        getMilestones();
        setMileStoneState("new");
        dispatch(addToast({ message: 'Milestone updated successfully', type: 'success' }));
        setMileStoneData({
          title: "",
          amount: "",
          description: "",
          status: selectedOption1,
        });
        setSelectedOption1('in-progress')
        setShowModal(false);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: 'error' }));
    } finally {
      setCreating(false);
    }
  };
 
 
  const handleDeleteMilestone = async (id) => {
    setMDeleting(true);
    try {
      const res = await fetchApi.delete(`/project-milestones/${id}/`, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      setMilestones((prevMilestones) =>
        prevMilestones.filter((milestone) => milestone.id !== id)
      );
      getMilestones()
      dispatch(addToast({ message: 'Milestone deletd successfully', type: 'success' }));
      setShowModal(false)
      setMileStoneData(
        {
          title: "",
          amount: "",
          description: "",
          status: selectedOption1,
        }
      )
      setMileStoneState('new')
    } catch (error) {
      dispatch(addToast({ message: error.message, type: 'error' }));
    } finally {
      setMDeleting(false);
    }
  };

  

  return (
    <div
      className={`w-full customFont ${theme === "dark" ? " text-white" : " text-black"}`}
    >
    
            <>
              <div className="fixed inset-0 bg-black bg-opacity-50 z-[1030]"></div>

              <div className="fixed inset-0 flex items-center justify-center z-[1040] ">
                <div
                  className={` p-6 rounded-[20px] shadow-lg max-w-screen-sm w-full max-h-[90vh] ${theme === "dark"
                    ? "bg-darkMode text-white"
                    : "bg-white text-black"
                    }`}
                >
                 <div className="flex justify-between">
                      <div className="flex gap-2 items-center">
                        <div
                          className={`p-1 rounded-full ${
                            theme === "dark"
                              ? " bg-gray-700 text-white"
                              : "bg-gray-300 text-black"
                          }`}
                        >
                          <IoIosArrowForward className="w-5 h-5" />
                        </div>
                        <h2 className="text-xl font-semibold">
                          {isEditing ? "Edit Milestone" : "New MileStone"}
                        </h2>
                      </div>
                      <div
                        className={`p-1 rounded-full ${
                          theme === "dark"
                            ? " bg-gray-700 text-white"
                            : "bg-gray-300 text-black"
                        }`}
                      >
                        <IoClose
                          className="w-6 h-6"
                          onClick={() => {
                            setEditingMileStone(null)
                           setOpen(false)
                          }}
                        />
                      </div>
                    </div>
                    <hr
                      className={`mt-4 ${
                        theme === "dark" ? "text-white" : "text-black bg-black"
                      }`}
                    />
                  <div className="flex flex-col w-full mt-4">
                  <label htmlFor="" className="font-semibold text-lg flex items-center gap-1 ">
                      <AiFillEdit className="w-5 h-5"/>
                      Title <span className="text-red-500 text-xl">*</span>
                    </label>
                    <input
                      type="text"
                      className={`text-base font-normal border p-2 bg-transparent outline-none w-full  rounded-[10px] ${
                        theme === "dark"
                          ? "placeholder:text-gray-600 border-gray-600 "
                          : "placeholder:text-gray-400 border-[#555657]"
                      } ${theme === "dark"
                          ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                          : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                        }`}
                      value={milstoneData.title}
                      onChange={(e) =>
                        setMileStoneData({
                          ...milstoneData,
                          title: e.target.value,
                        })
                      }
                      placeholder="add title"
                    />
                    <div className="grid grid-cols-2 mt-4 gap-4 ">
                    <div className="w-full">
                    <label htmlFor="" className="font-semibold text-lg flex items-center gap-1 ">
                      <BiSolidDollarCircle className="w-5 h-5"/>
                      Amount <span className="text-red-500 text-xl">*</span>
                    </label>
                    <input
                      type="text"
                      className={`text-base font-normal p-2 bg-transparent outline-none mt-2 w-full  rounded-[10px] border ${
                        theme === "dark"
                          ? "placeholder:text-gray-600 border-gray-600 "
                          : "placeholder:text-gray-400 border-[#555657]"
                      } ${theme === "dark"
                          ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                          : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                        }`}
                      value={milstoneData.amount}
                      onChange={(e) =>
                        setMileStoneData({
                          ...milstoneData,
                          amount: e.target.value,
                        })
                      }
                      placeholder="add amount"
                    />
                    </div>
                    <div className="w-full">
                    <label htmlFor="" className="font-semibold text-lg flex items-center gap-1 ">
                      <FaClipboardList className="w-5 h-5"/>
                      Status <span className="text-red-500 text-xl">*</span>
                    </label>
                    <div className="flex relative gap-4 mt-2 w-full">
                      <div className="flex flex-col gap-1 w-full">
                        <div
                          className={`flex w-full items-center justify-between px-2 text-base py-2 cursor-pointer   rounded-[10px] border ${
                        theme === "dark"
                          ? "placeholder:text-gray-600 border-gray-600 "
                          : "placeholder:text-gray-400 border-[#555657]"
                      }`}
                          onClick={() => setIsDropdownOpen1(!isDropdownOpen1)}
                        >
                          <div className="flex items-center gap-1">
                            {
                              options.find(
                                (option) => option.label === selectedOption1
                              )?.icon
                            }
                            <span className=" capitalize">
                              {selectedOption1}
                            </span>
                          </div>
                        </div>
                      </div>

                      {isDropdownOpen1 && (
                        <div
                          className={`absolute top-full left-0 mt-2 w-full shadow-lg rounded-md z-10 ${theme === "dark"
                            ? "bg-dashboardDarkMode text-white"
                            : "bg-lightMode text-black"
                            }`}
                        >
                          {options.map((option) => (
                            <div
                              key={option.label}
                              className={`flex items-center px-3 py-2 cursor-pointer ${theme === "dark"
                                ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                                : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                                }`}
                              onClick={() => {
                                setSelectedOption1(option.label);
                                setIsDropdownOpen1(false);
                              }}
                            >
                              {option.icon}
                              <span className="capitalize">{option.label}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 w-full mt-4">
                      <div className="w-full">
                      <label htmlFor="" className="font-semibold text-lg flex items-center gap-1 ">
                      <FaCalendarAlt className="w-5 h-5"/>
                      Start Date <span className="text-red-500 text-xl">*</span>
                    </label>
                        <div
                          className={`cursor-pointer relative bg-transparent w-full flex justify-between items-center outline-none border px-2 py-2 mt-2  rounded-[10px] ${
                        theme === "dark"
                          ? "placeholder:text-gray-600 border-gray-600 "
                          : "placeholder:text-gray-400 border-[#555657]"
                      }`}
                        >
                          <span
                            className="w-full flex items-center justify-between"
                            onClick={() => {
                              setStartDateDropdown(!startDateDropdown);
                              setEndDateDropdown(false);
                            }}
                          >
                            {milstoneData.started_at
                              ? milstoneData.started_at
                              : "Choose date"}{" "}
                            <button>
                              {startDateDropdown ? (
                                <FaChevronUp className="w-4 h-4 " />
                              ) : (
                                <FaChevronDown className="w-4 h-4" />
                              )}
                            </button>
                          </span>
                          {startDateDropdown && (
                            <Calendar
                              theme={theme}
                              onDateSelect={(date) => {
                                milstoneData.started_at = date;
                                setStartDateDropdown(false);
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="w-full">
                      <label htmlFor="" className="font-semibold text-lg flex items-center gap-1 ">
                      <FaCalendarAlt className="w-5 h-5"/>
                      End Date <span className="text-red-500 text-xl">*</span>
                    </label>
                        <div
                          className={`relative cursor-pointer bg-transparent mt-2 w-full outline-none px-2 py-2  rounded-[10px] border ${
                        theme === "dark"
                          ? "placeholder:text-gray-600 border-gray-600 "
                          : "placeholder:text-gray-400 border-[#555657]"
                      }`}
                        >
                          <span
                            className="w-full flex items-center justify-between"
                            onClick={() => {
                              setEndDateDropdown(!endDateDropdown);
                              setStartDateDropdown(false);
                            }}
                          >
                            {milstoneData.completed_at
                              ? milstoneData.completed_at
                              : "Choose date"}{" "}
                            <button>
                              {endDateDropdown ? (
                                <FaChevronUp className="w-4 h-4 " />
                              ) : (
                                <FaChevronDown className="w-4 h-4" />
                              )}
                            </button>
                          </span>
                          {endDateDropdown && (
                            <Calendar
                              theme={theme}
                              onDateSelect={(date) => {
                                milstoneData.completed_at = date;
                                setEndDateDropdown(false);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <label htmlFor="" className="font-semibold text-lg mt-4 mb-2">
                     Milestone Description
                    </label>
                    <RichTextEditor1 setProjectData={setMileStoneData} projectData={milstoneData} />
                    <div className="flex gap-2 justify-end pt-4 mt-6">
                      <button
                        className={` border rounded-3xl px-3 py-2 bg-transparent  ${theme === "dark"
                          ? "border-gray-700"
                          : "border-gray-500"
                          }`}
                        onClick={() => {
                          setOpen(false)
                          setEditingMileStone(null)
                          setMileStoneState('new')
                          setMileStoneData({
                            title: '',
                            description: '',
                            amount: '',
                          })
                          setSelectedOption1('in-progress')
                          setIsEditing(false)
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="heroButton"
                        disabled={creating}
                        onClick={() => {
                          if (mileStoneState === "new") {
                            handleSubmit();
                          } else {
                            handleUpdate(mileStoneId);
                          }
                        }}
                      >
                        {creating
                          ? mileStoneState === "new"
                            ? "Creating..."
                            : "Updating..."
                          : mileStoneState === "new"
                            ? "Create"
                            : "Update"}
                      </button>
                      {mileStoneState !== "new" &&
                        <button className="heroButton" onClick={() => handleDeleteMilestone(mileStoneId)} disabled={mdeleting}>{mdeleting ? 'Deleting...' : 'Delete'}</button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </>
         
        </div>
  );
};

export default ProjectDetail;
